import _ from 'underscore';
import Promise from 'bluebird';

/* Converts the query generated by query builder to the format expected by JSData layer.
   Useful for when projection-grid is not used, as that logic is currently inside pgrid.
*/
export class JsDataQueryConverter {
  static convert(queryParams) {
    return Promise.resolve({
      query: this.translateParams(_.omit(queryParams, 'options')),
      options: queryParams.options,
    });
  }

  static translateOrderBy(orderByParams) {
    const orderBy = _
      .chain(this.normalizeOrderBy(orderByParams))
      .map(([key, direction]) => [key, direction > 0 ? 'ASC' : 'DESC'])
      .value();

    return _.isEmpty(orderBy) ? null : orderBy;
  }

  static translateParams(params) {
    return _
      .chain(params)
      .omit('skip', 'take', 'filter', 'orderby')
      .extend(_.pick(
        {
          offset: params.skip,
          limit: params.take,
          where: params.filter,
          orderBy: this.translateOrderBy(params.orderby),
        },
        Boolean
      ))
      .value();
  }

  static normalizeOrderBy(orderBy = []) {
    // Below code is taken from pgrid and will be extracted out.
    // Ignore eslint errors in here for now as to not diverge it from original.
    /* eslint-disable */
    return _.reduce(_.isArray(orderBy) ? orderBy : [orderBy], (memo, item) => {
      let key = null;
      let direction = null;

      if (_.isArray(item)) {
        key = item[0];
        direction = item[1];
      } else if (_.isObject(item)) {
        key = item.key;
        direction = item.direction;
      }

      if (!_.isNumber(direction)) {
        throw new Error('Invalid direction option for orderBy');
      }

      if (!direction) {
        return memo;
      }

      if (_.isFunction(key)) {
        return memo.concat(this.normalizeOrderBy(key(direction)));
      }

      if (_.isString(key)) {
        memo.push([key, direction]);
        return memo;
      }

      throw new Error('Invalid key option for orderBy');
    }, []);
    /* eslint-enable */
  }
}
